import React from 'react';
import { Box,Container, Typography, Grid, Chip, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import mockTopics from '../data/mockChats.json'; // Reusing mockTopics data

// Add some more mock topics to fill out the grid
const fullTopics = [
    ...mockTopics,
    { id: 6, name: "Education", icon: "Book" },
    { id: 7, name: "Safety", icon: "Security" },
    { id: 8, name: "Parenting", icon: "FamilyRestroom" },
];

export const TopicSelector = () => {
    const theme = useTheme();

    return (
        <Box sx={{ py: 6 }}>
            <Container maxWidth="lg">
                <Typography 
                    variant="h3" 
                    align="center" 
                    sx={{ mb: 5, fontWeight: 700, color: theme.palette.text.primary }}
                >
                    Explore Key Topics
                </Typography>
                <Grid container spacing={2} justifyContent="center">
                    {fullTopics.map((topic) => (
                        <Grid item key={topic.id}>
                            <Chip
                                label={topic.name}
                                component={Link}
                                to={`/resources?topic=${topic.name.toLowerCase().replace(/\s/g, '-')}`}
                                clickable
                                sx={{
                                    fontSize: '1rem',
                                    fontWeight: 600,
                                    py: 3,
                                    px: 2,
                                    borderRadius: 8,
                                    bgcolor: theme.palette.secondary.light,
                                    color: theme.palette.text.primary,
                                    '&:hover': {
                                        bgcolor: theme.palette.secondary.main,
                                        boxShadow: 3
                                    }
                                }}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};